// Permission-гейт домену ui-kit. Placeholder — джерела прав ще немає.
// Коли зʼявиться: export const uiKitLoader = requirePermission('view:ui-kit');
export const uiKitLoader = () => null;
